import * as Yup from "yup";
import { getPatchOperations } from "../../../util/form";
import { dateToyyyyMMdd } from "../../../util/date";

export const adminKodelisteEfteruddannelsestypeForm = (
  kodelisteQueryType: KodelisteQueryType,
  nameList: string[],
  nr?: number,
): FormConfig<KodelisteEfteruddannelsestypeDTO> => {
  return {
    title: "Persontype",
    lockedValues: [{ id: "nr", value: nr }],
    validationSchema: Yup.object({
      navn: Yup.string()
        .test("nameExistsTest", "Dette navn findes allerede", function () {
          return !nameList.some((name) => name === this.parent.navn);
        })
        .required("Kan ikke oprettes uden et navn"),
      formaal: Yup.number().required("Skal være sat"),
      periodeFraDato: Yup.date().nullable().required("Skal være sat"),
      periodeTilDatoInklusiv: Yup.date().nullable(),
      maxLektioner: Yup.number().required("Skal være sat"),
      overfoerPrioritet: Yup.number().required("Skal være sat"),
      overfoerTilMax: Yup.boolean().required("Skal være sat"),
    }),
    form: [
      {
        component: "textinput",
        id: "navn",
        initialValue: "",
        label: "Navn",
        placeholder: " ",
        isRequired: true,
      },
      {
        component: "datepicker",
        id: "periodeFraDato",
        initialValue: "",
        label: "Fra dato",
        isRequired: true,
      },
      {
        component: "datepicker",
        id: "periodeTilDatoInklusiv",
        initialValue: "",
        label: "Til dato",
      },
      {
        component: "textinput",
        id: "formaal",
        initialValue: "",
        label: "Formål",
        placeholder: 'f.eks. "0"',
        isRequired: true,
      },
      {
        component: "textinput",
        id: "maxLektioner",
        initialValue: "",
        label: "Maks lektioner",
        placeholder: 'f.eks. "54" ',
        isRequired: true,
      },
      {
        component: "textinput",
        id: "overfoerPrioritet",
        initialValue: "",
        label: "Overfør prioritet",
        placeholder: 'f.eks. "1"',
        isRequired: true,
      },
      {
        component: "boolean",
        id: "overfoerTilMax",
        initialValue: false,
        label: "Overfør til maks",
        isRequired: true,
      },
    ],
    get: `kodelister/${kodelisteQueryType}/${nr}`,
    post(values) {
      return {
        query: `kodelister/${kodelisteQueryType}`,
        body: {
          ...values,
          periodeFraDato: dateToyyyyMMdd(values.periodeFraDato),
          periodeTilDatoInklusiv: values.periodeTilDatoInklusiv
            ? dateToyyyyMMdd(values.periodeTilDatoInklusiv)
            : "9999-12-31",
        },
      };
    },
    patch(values) {
      const ops = getPatchOperations(values);

      return {
        query: `kodelister/${kodelisteQueryType}/${nr}`,
        body: JSON.stringify(ops),
      };
    },
    delete() {
      return {
        query: `kodelister/${kodelisteQueryType}/${nr}`,
      };
    },
  };
};
